<template>

<com-item name="hindex.plays" :size="size" :is-empty="!active" :loading="loading" title="Play Count">

	<template v-slot:about>

		<p>See how many plays users have with the same H-index.</p>

	</template>

	<template v-slot:stats>

		<core-widget :is-slim="true">

			<div class="durations-list">

				<div class="durations-list-shading">
					<div class="durations-list-shading-item" v-for="(band, index) in bands" :key="index">{{band.from}}-{{band.to}}</div>
				</div>

				<div class="durations-list-item" v-tooltip="tooltip(duration, index)" v-for="(duration, index) in data.values" :key="index">
					<div :style="height(duration)" :class="{'is-highlighted': data.self === index}"></div>
				</div>

			</div>

		</core-widget>

	</template>

</com-item>

</template>

<script>

import comItem from './../common/Item'

export default {

	props: ['fetching', 'you', 'your', 'size'],

	components: {
		'com-item': comItem
	},

	computed: {

        bands: function() {

            var bands = []

            for (var i=0; i<10; i++) {

                bands.push({
                    from: this.data.min + (i * 100),
                    to: this.data.min + (i * 100) + 100
                })

            }

            return bands

        },

		loading: function() {

			return this.fetching === 'all'

		},

		data: function() {

			return this.$store.getters['page/insights/hindex/plays']

		},

		active: function() {

			return this.data.values && !this.loading

		},

        max: function() {

			return this.$_.max(this.data.values, function(duration) {

				return duration

			})

		}

	},

	methods: {

		tooltip: function(value, index) {

			return (index * 10).toString() + ' - ' + ((index * 10) + 9).toString() + ' plays<small>' + value.toString() + ' user' + ((value === 1) ? '' : 's') + '</small>'

		},

		height: function(value) {

			return {
				height: ((100 / this.max) * value).toString() + '%',
			}

		}

	}

}

</script>

<style scoped>

.durations {
	padding: 0px!important;
	height: 240px;
}

.durations-list {
	width: 100%;
	min-width: 640px;
	height: 100%;
	display: flex;
	align-items: center;
}

.durations-list-shading {
	z-index: 1;
	position: absolute;
	left: 0px;
	top: 0px;
	width: 100%;
	height: 100%;
	display: flex;
}

.durations-list-shading-item {
	width: calc(100% / 10);
	height: 100%;
	font-size: 16px;
	font-weight: 700;
	text-align: center;
	color: #a0c3cf;
	padding: 5px;
}

.durations-list-shading-item:nth-child(even) {
	background-color: rgba(12, 137, 178, 0.05);
}

.durations-list-item {
	height: 100%;
	padding: 25px 0px;
	width: calc(100% / 100);
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	z-index: 2;
}

.durations-list-item:hover {
	background-color: rgba(12, 137, 178, 0.1);
}

.durations-list-item div {
	width: calc(100% - 2px);
	border-radius: 4px;
	min-height: 2px;
	background-color: #4881bb;
	transition: height 100ms linear;
}

.durations-list-item div.is-highlighted {
	background-color: #3bce5a;
}

</style>